var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAlignLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 1,
  y: 1,
  width: 3,
  height: 19
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.000000, 5.000000)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 4,
  width: 8,
  height: 3,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  transform: "translate(3.914214, 4.085786) rotate(-45.000000) translate(-3.914214, -4.085786) ",
  x: 0.414213562,
  y: 2.58578644,
  width: 7,
  height: 3,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  transform: "translate(3.914214, 6.914214) rotate(-45.000000) translate(-3.914214, -6.914214) ",
  x: 2.41421356,
  y: 3.41421356,
  width: 3,
  height: 7,
  rx: 1
})))));
export default SvgAlignLeft;